import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App.jsx";
import "@/styles/index.scss";
import "./utils/i18n.js";
import { PostHogProvider } from "posthog-js/react";
import UnderConstruction from "./components/providers/under-construction/UnderConstruction.jsx";

console.info(`Version: ${process.env.VITE_VERSION}`);

const wrapPostHog = (app) => {
  const publicKey = process.env.VITE_PUBLIC_POSTHOG_KEY;
  const host = process.env.VITE_PUBLIC_POSTHOG_HOST;
  if (!publicKey || !host) {
    return app;
  } else {
    return (
      <PostHogProvider
        apiKey={process.env.VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: process.env.VITE_PUBLIC_POSTHOG_HOST,
        }}
      >
        <UnderConstruction>{app}</UnderConstruction>
      </PostHogProvider>
    );
  }
};

createRoot(document.getElementById("root")).render(
  <StrictMode>{wrapPostHog(<App />)}</StrictMode>
);
